import { type FC } from "react";
import { Chip, type ChipProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BroadcastStateType } from "@/types/graphql/partner.generated";
import { BROADCAST_STATE_KEYS } from "../model/broadcastLabels";

const STATE_COLORS: Record<BroadcastStateType, ChipProps["color"]> = {
  [BroadcastStateType.DraftType]: "default",
  [BroadcastStateType.ScheduledType]: "info",
  [BroadcastStateType.SendingType]: "warning",
  [BroadcastStateType.SentType]: "success",
  [BroadcastStateType.ArchivedType]: "default",
};

/** Состояние рассылки чипом цвета темы; архив контурный, чтобы не спорить с черновиком. */
export const BroadcastStateChip: FC<{ state: BroadcastStateType }> = ({
  state,
}) => {
  const { t } = useTranslation();
  return (
    <Chip
      size="small"
      color={STATE_COLORS[state]}
      variant={
        state === BroadcastStateType.ArchivedType ? "outlined" : "filled"
      }
      label={t(BROADCAST_STATE_KEYS[state])}
    />
  );
};
